/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/710/interface/api/cat_4410
 */
import { message } from 'ant-design-vue'
import { reactive, toRefs, ref } from 'vue'
import {
  v1_portal_role_add_post,
  v1_portal_role_list_post,
  v1_portal_role_delete_post,
  v1_portal_role_update_post,
  v1_portal_role_batchModule_post,
  v1_portal_role_assignModule_post,
  v1_portal_role_byUserId_post
} from 'server/modules/4410' // 工作台权限管理-添加角色

export const v1_portal_role_add_post_ = function(option) {
  const formState = reactive({
    id: null,
    roleName: null,
    visible: false
  })
  const rules = reactive({
    roleName: [
      {
        required: true,
        message: '请输入角色名称'
      }
    ]
  })
  const formRef = ref(null)
  const addRole = async () => {
    const { success, data, retInfo } = await v1_portal_role_add_post({
      roleName: formState.roleName
    })
    if (success) {
      showModal(false)
      message.success('新增角色成功')
      option.getRoleList()
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  const updateRole = () => {
    v1_portal_role_update_post_(formState, () => {
      showModal(false)
      option.getRoleList()
    })
  }
  const deleteRole = id => {
    v1_portal_role_delete_post_(id, () => {
      showModal(false)
      option.getRoleList()
    })
  }

  const showModal = (visible, record) => {
    formState.visible = visible

    if (record) {
      Object.assign(formState, record)
    } else {
      Object.assign(formState, {
        roleName: null,
        id: null
      })
    }
  }
  const submitRole = () => {
    formRef.value.validate().then(() => {
      formState.id ? updateRole() : addRole()
    })
  }
  return {
    formRef,
    rules,
    formState,
    showModal,
    deleteRole,
    submitRole
  }
} // 工作台权限管理-查询所有角色

export const v1_portal_role_list_post_ = function() {
  const state = reactive({
    roleDatas: []
  })
  const columns = [
    {
      title: '角色ID',
      dataIndex: 'id',
      key: 'id',
      width: 80
    },
    {
      title: '角色名称',
      dataIndex: 'roleName',
      key: 'roleName'
    },
    {
      title: '操作',
      key: 'action'
    }
  ]
  const getRoleList = async () => {
    const { success, data, retInfo } = await v1_portal_role_list_post({
      roleName: ''
    })

    if (success) {
      state.roleDatas = data.list
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }

  return {
    columns,
    getRoleList,
    ...toRefs(state)
  }
} // 工作台权限管理-删除角色

export const v1_portal_role_delete_post_ = async function(id, callback) {
  const { success, data, retInfo } = await v1_portal_role_delete_post({
    id
  })
  if (success) {
    callback()
    message.success('删除成功')
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 工作台权限管理-更新角色名称

export const v1_portal_role_update_post_ = async function(params, callback) {
  const { id, roleName } = params
  const { success, data, retInfo } = await v1_portal_role_update_post({
    id,
    roleName
  })
  if (success) {
    callback()
    message.success('更新角色成功')
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 工作台权限管理-批量给角色关联模块

export const v1_portal_role_batchModule_post_ = async function(params, close) {
  const { success, data, retInfo } = await v1_portal_role_batchModule_post(
    params
  )

  if (success) {
    console.log(data)
    message.success('批量分配成功')
    close()
  } else {
    console.log(data)
    message.error(retInfo)
  }
} // 工作台权限管理-给角色关联模块

export const v1_portal_role_assignModule_post_ = async function(params, close) {
  const { success, data, retInfo } = await v1_portal_role_assignModule_post(
    params
  )
  if (success) {
    console.log(data)
    close()
    message.success('分配成功')
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
export const assignController = function(getModuleListByRoleId) {
  const assignState = reactive({
    moduleIds: [],
    roleId: null,
    roleIds: []
  }) // 批量分配

  const isBatch = ref(false) // 关联模块弹框

  const isAssignModal = ref(false) // 显示关联模块弹框

  const showAssignModal = record => {
    isAssignModal.value = true
    assignState.roleId = record.id
    getModuleListByRoleId(record.id)
    isBatch.value = false
  }

  const closeModal = () => {
    isAssignModal.value = false
  }

  const setRoleIds = roleIds => {
    assignState.roleIds = roleIds
  } // 提交

  const assignSubmit = () => {
    if (isBatch.value) {
      v1_portal_role_batchModule_post_(
        {
          roleIds: assignState.roleIds,
          moduleIds: assignState.moduleIds
        },
        closeModal
      )
    } else {
      v1_portal_role_assignModule_post_(
        {
          roleId: assignState.roleId,
          moduleIds: assignState.moduleIds
        },
        closeModal
      )
    }
  }
  return {
    isBatch,
    isAssignModal,
    showAssignModal,
    assignState,
    assignSubmit,
    setRoleIds
  }
}

// 工作台权限管理-根据用户ID查询所有的角色
export const v1_portal_role_byUserId_post_ = function(state) {
  const getRoleListByID = async userId => {
    const { success, data, retInfo } = await v1_portal_role_byUserId_post({
      userId: userId
    })
    if (success) {
      state.roleList = data
    } else {
      console.log(data)
      message.error(retInfo)
    }
  }
  return {
    getRoleListByID
  }
}
